
import React from 'react';
import YoutubeRenderer from './special-renderers/YoutubeRenderer';
import CandidateGenerationRenderer from './special-renderers/CandidateGenerationRenderer';

interface SpecialArticleRendererProps {
  slug: string;
  content: string;
  isProduction: boolean;
  isMarkdown?: boolean; // Added this prop to match what's being passed in index.tsx
}

/**
 * Renderer component for special articles that need custom rendering logic
 */
const SpecialArticleRenderer: React.FC<SpecialArticleRendererProps> = ({ 
  slug, 
  content,
  isProduction,
  isMarkdown = true // Default to true as most special renderers assume markdown content
}) => {
  switch (slug) {
    case 'youtube-recommendation-system':
      return <YoutubeRenderer content={content} />;
      
    case 'candidate-generation':
      return <CandidateGenerationRenderer content={content} isProduction={isProduction} />;
      
    default:
      // If no special renderer is found, just return null and let the parent component handle it
      return null;
  }
};

export default SpecialArticleRenderer;
